import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTranslation from "@babackapp/translations/use-translation";
import useQuickStats from "../lib/use-quick-stat";
import { refundColor } from "./colors";
import { QuickStatCard } from "./quick-stat-card";

export default function QuickStatRefundCard() {
  const t = useTranslation();
  const stats = useQuickStats("refund");
  const { data: shop } = useCurrentShopSuspense();

  return (
    <QuickStatCard
      count={stats.count}
      value={stats.value}
      currency={shop.preferences.currency}
      evolution={5}
      title={t("analyticsDashboard.resolutionTypes.refund")}
      subtitle={t("analyticsDashboard.quickStats.refund")}
      percentage={stats.percentage}
      color={refundColor}
    />
  );
}
